import { css, styled } from 'styled-components';
import { Dotdotdot } from './Dotdotdot';
const getLineHeight = (lineHeight) => css `
  line-height: ${lineHeight};
`;
export const ClampedLinkWorkaround = styled(Dotdotdot) `
  margin: ${({ margin }) => margin !== null && margin !== void 0 ? margin : -6}px;
  padding: ${({ padding }) => padding !== null && padding !== void 0 ? padding : 6}px;
  word-break: break-word;

  ${({ lineHeight }) => lineHeight && getLineHeight(lineHeight)};
`;
//# sourceMappingURL=ClampedLinkWorkaround.js.map